import { useCallback, useEffect, useState } from "react";
import {
  type KarunaPageSize,
  KARUNA_PAGE_SIZE_CHANGE_EVENT,
  readKarunaPageSize,
  writeKarunaPageSize,
} from "@/project/karuna/constants/listPagination";

export function useKarunaPageSize() {
  const [pageSize, setPageSizeState] = useState<KarunaPageSize>(() =>
    readKarunaPageSize()
  );

  useEffect(() => {
    const handler = (event: Event) => {
      const next = (event as CustomEvent<KarunaPageSize>).detail;
      if (next) {
        setPageSizeState(next);
      }
    };

    window.addEventListener(KARUNA_PAGE_SIZE_CHANGE_EVENT, handler);
    return () =>
      window.removeEventListener(KARUNA_PAGE_SIZE_CHANGE_EVENT, handler);
  }, []);

  const setPageSize = useCallback((size: KarunaPageSize) => {
    writeKarunaPageSize(size);
    setPageSizeState(size);
  }, []);

  return { pageSize, setPageSize };
}
